export const DUNNING_URL = "/pay-now";

export const segmentCategories = {
  [DUNNING_URL]: "Payment",
};
